import React from "react";

const Checkbox = ({ label, checked, onChange }) => {
    return (
        <div className="flex items-center space-x-2">
            <input
                type="checkbox"
                checked={checked}
                onChange={onChange}
                className="h-4 w-4 text-blue-600"
            />
            <label className="text-gray-700">{label}</label>
        </div>
    );
};

export default Checkbox;
